import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 26px;
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  ${screen.md} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${screen.lg} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const AgentCard = styled.a`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  border-radius: 14px;
  border: 1px solid ${homeColor.line};
  background: rgba(12, 35, 40, 0.5);
  transition:
    border-color 0.15s,
    background 0.15s;

  &:hover {
    border-color: ${homeColor.line2};
    background: rgba(12, 35, 40, 0.8);
  }
`;

export const CardTitle = styled.p`
  font-family: ${getToken('font-family-title')};
  font-weight: 700;
  font-size: 20px;
  color: ${homeColor.white};
  margin: 0 0 12px;
`;

export const CardDescription = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  font-size: 15px;
  line-height: 1.5;
  color: ${homeColor.muted};
  margin: 0;
`;

export const CardReadMore = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.18em;
  color: ${homeColor.green};
  margin: 0;
`;
